import {
  AutomationChannel,
  AutomationTrigger,
  AutomationTriggerHumanNames,
} from 'apis/automations';

import { FeatureFlaggedOptions } from './automations.types';

export const VOICE_CHANNEL_IDS: AutomationChannel[] = [
  AutomationChannel.PSTNPHONE,
  AutomationChannel.VOICEMAIL,
  AutomationChannel.CALLBACK,
];

export const CONDITION_NODE_LABEL = 'Condition';
export const INIT_NODE_LABEL = 'Trigger';

export const MATCH_BOOLEAN_DEFAULT_VALUE = {
  value: 'true',
  meta: { label: 'True' },
};

export const triggerOptions: FeatureFlaggedOptions<AutomationTrigger>[] = [
  {
    id: AutomationTrigger.CONVERSATION_ASSIGNED,
    name: AutomationTriggerHumanNames.CONVERSATION_ASSIGNED,
  },
  {
    id: AutomationTrigger.CONVERSATION_ABANDONED,
    name: AutomationTriggerHumanNames.CONVERSATION_ABANDONED,
  },
  {
    id: AutomationTrigger.CONVERSATION_CLOSED,
    name: AutomationTriggerHumanNames.CONVERSATION_CLOSED,
  },
  {
    id: AutomationTrigger.CONVERSATION_ADDED_TO_QUEUE,
    name: AutomationTriggerHumanNames.CONVERSATION_ADDED_TO_QUEUE,
  },
  {
    id: AutomationTrigger.MESSAGE_SEND_BY_AGENT,
    name: AutomationTriggerHumanNames.MESSAGE_SEND_BY_AGENT,
  },
  {
    id: AutomationTrigger.MESSAGE_SEND_BY_USER,
    name: AutomationTriggerHumanNames.MESSAGE_SEND_BY_USER,
  },
  {
    id: AutomationTrigger.CONVERSATION_TAGGED,
    name: AutomationTriggerHumanNames.CONVERSATION_TAGGED,
  },
  {
    id: AutomationTrigger.CONVERSATION_UNTAGGED,
    name: AutomationTriggerHumanNames.CONVERSATION_UNTAGGED,
  },
  {
    id: AutomationTrigger.CONVERSATION_CUSTOM_ATTRIBUTE_UPDATED,
    name: AutomationTriggerHumanNames.CONVERSATION_CUSTOM_ATTRIBUTE_UPDATED,
  },
  {
    id: AutomationTrigger.CONVERSATION_FIRST_MESSAGE_ADDED,
    name: AutomationTriggerHumanNames.CONVERSATION_FIRST_MESSAGE_ADDED,
  },
  {
    id: AutomationTrigger.EXTERNAL_TRIGGER,
    name: AutomationTriggerHumanNames.EXTERNAL_TRIGGER,
  },
  {
    id: AutomationTrigger.CONVERSATION_RATING_UPDATED,
    name: AutomationTriggerHumanNames.CONVERSATION_RATING_UPDATED,
  },
  {
    id: AutomationTrigger.SLA_BREACHED,
    name: AutomationTriggerHumanNames.SLA_BREACHED,
  },
  {
    id: AutomationTrigger.TRANSCRIPTION_COMPLETED,
    name: AutomationTriggerHumanNames.TRANSCRIPTION_COMPLETED,
    featureFlag: ['automation-transcription-completed-trigger'],
  },
];

export const channelOptions: FeatureFlaggedOptions<AutomationChannel>[] = [
  {
    id: AutomationChannel.CONTACTFORM,
    alternateIds: ['contactform'],
    name: 'Contact form',
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.EMAIL,
    name: 'Email',
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.FACEBOOKMESSENGER,
    alternateIds: ['facebookmessenger'],
    name: 'Facebook Messenger',
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.MESSENGER,
    name: 'Messenger',
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.SMS,
    name: 'SMS',
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.WHATSAPP,
    alternateIds: ['whatsapp'],
    name: 'WhatsApp',
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  // Partner channels
  {
    id: AutomationChannel.ADACHAT,
    name: 'Ada Chat',
    featureFlag: ['ada-chat-channel'],
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.DIGITALGENIUSCHAT,
    name: 'DigitalGenius Chat',
    featureFlag: ['digitalgenius-chat-channel'],
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.KINDLYCHAT,
    name: 'Kindly Chat',
    featureFlag: ['kindly-chat-channel'],
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  {
    id: AutomationChannel.GENERICAPIMESSAGING,
    name: 'Generic API Messaging',
    featureFlag: ['generic-api-messaging-channel'],
    excludedForTriggers: [AutomationTrigger.TRANSCRIPTION_COMPLETED],
  },
  // Voice channels
  {
    id: AutomationChannel.PSTNPHONE,
    name: 'Phone',
    excludedForTriggers: [
      AutomationTrigger.MESSAGE_SEND_BY_AGENT,
      AutomationTrigger.MESSAGE_SEND_BY_USER,
    ],
  },
  {
    id: AutomationChannel.VOICEMAIL,
    name: 'Voicemail',
    excludedForTriggers: [
      AutomationTrigger.MESSAGE_SEND_BY_AGENT,
      AutomationTrigger.MESSAGE_SEND_BY_USER,
    ],
  },
  {
    id: AutomationChannel.CALLBACK,
    name: 'Callback',
    excludedForTriggers: [
      AutomationTrigger.MESSAGE_SEND_BY_AGENT,
      AutomationTrigger.MESSAGE_SEND_BY_USER,
    ],
  },
];

export const featureFlagList = [
  ...triggerOptions.flatMap((option) => option.featureFlag ?? []),
  ...channelOptions.flatMap((option) => option.featureFlag ?? []),
];
